const TITLE_BASE = "Eloria";

let audioContext: AudioContext | null = null;
let titleTimer: number | null = null;
let titleAlerting = false;

export function unlockManagerAlerts(): void {
  if (typeof window === "undefined") {
    return;
  }
  const AudioCtx =
    window.AudioContext ||
    (window as Window & { webkitAudioContext?: typeof AudioContext })
      .webkitAudioContext;
  if (AudioCtx && audioContext == null) {
    audioContext = new AudioCtx();
  }
  void audioContext?.resume();
  if (
    typeof Notification !== "undefined" &&
    Notification.permission === "default"
  ) {
    void Notification.requestPermission();
  }
}

export function playManagerAlertSound(): void {
  const ctx = audioContext;
  if (!ctx) {
    return;
  }
  void ctx.resume();
  const now = ctx.currentTime;
  [880, 1175].forEach((frequency, index) => {
    const oscillator = ctx.createOscillator();
    const gain = ctx.createGain();
    oscillator.type = "sine";
    oscillator.frequency.value = frequency;
    gain.gain.setValueAtTime(0.0001, now);
    gain.gain.exponentialRampToValueAtTime(0.35, now + index * 0.18 + 0.02);
    gain.gain.exponentialRampToValueAtTime(0.0001, now + index * 0.18 + 0.22);
    oscillator.connect(gain);
    gain.connect(ctx.destination);
    oscillator.start(now + index * 0.18);
    oscillator.stop(now + index * 0.18 + 0.24);
  });
}

export function startTitleAlert(locale: "es" | "en", count: number): void {
  if (typeof document === "undefined") {
    return;
  }
  const alertTitle =
    locale === "es"
      ? `(${count}) Eloria te escribió`
      : `(${count}) Eloria messaged you`;
  if (titleTimer != null) {
    window.clearInterval(titleTimer);
  }
  titleAlerting = true;
  let showAlert = true;
  document.title = alertTitle;
  titleTimer = window.setInterval(() => {
    if (!titleAlerting) {
      return;
    }
    document.title = showAlert ? alertTitle : TITLE_BASE;
    showAlert = !showAlert;
  }, 900);
}

export function stopTitleAlert(): void {
  titleAlerting = false;
  if (titleTimer != null) {
    window.clearInterval(titleTimer);
    titleTimer = null;
  }
  if (typeof document !== "undefined" && document.title !== TITLE_BASE) {
    document.title = TITLE_BASE;
  }
}

export function showSystemNotification(
  title: string,
  body: string,
  onClick: () => void
): void {
  if (typeof Notification === "undefined" || Notification.permission !== "granted") {
    return;
  }
  const notification = new Notification(title, {
    body,
    requireInteraction: true,
  });
  notification.onclick = () => {
    window.focus();
    onClick();
    notification.close();
  };
}

export function tabIsBackground(): boolean {
  return document.visibilityState !== "visible" || !document.hasFocus();
}
